module.exports = __webpack_public_path__ + "static/media/0222.8a3fc4d6.png";